import PropTypes from 'prop-types';
import React from 'react';

import {AllTypesShort} from '../constants/salesCostTypes';

function SalesCostTypeLabel({ value }:{value:number}) {
  return (
    <span>{AllTypesShort[value] || ''}</span>
  );
}

SalesCostTypeLabel.propTypes = {
  value: PropTypes.number.isRequired,
};

export default React.memo(SalesCostTypeLabel);
